export default {
    "error": {
      "required": "Campo richiesto",
      "forbiddenSymbols": "Alcuni simboli non sono validi ",
      "numeric": "Il campo deve essere numerico",
      "minMax": "Il campo deve essere compreso tra  {0} e {1} caratteri",
      "email": "Mail non valida",
      "amount": "Importo non valido",
      "selectedPlayer": "Seleziona un giocatore",
      "passwordsMismatch": "La password non combacia",
      "samePasswords": "La nuova e la vecchia password sono uguali ",
      "signInUp": {
        "1": "La username non esiste",
        "2": "Password errata ",
        "4": "La password deve contenere sia numeri che lettere ed avere da 6 a 16 caratteri",
        "5": "Devi fonire una mail valida",
        "6": "La mail non e' collegata a nessun account",
        "7": "Il campo e' vuoto",
        "8": "La username deve avere almeno 3 simboli",
        "9": "Numero massino simboli 16",
        "10": "No spazi",
        "11": "Accetta termini e condizioni ",
        "422": "La username e' gia' utilizzata "
      },
      "invalidTableName": "Nome tavolo non valido"
    },
    "messages": {
      "joinClubSucces": "Richiesta di partecipazione inviata con successo",
      "createClubSuccess": "Nuovo Clube creato correttamente",
      "balanceTransferSuccess": "Trasferimento avvenuto con successo",
      "waitingForData": "In attesa di un dato",
      "deleteSuccess": "Account eliminato con successo ",
      "changePasswordSuccess": "La password e' stata modificata ",
      "forgotPasswordSuccess": "La tua richiesta e' stata inviata correttamente",
      "counterMessage1": "Invia da {0} a {1}",
      "clubWrongBalanceMessage1": "Hai solo {0} ma vuoi trasferire un importo totale {1} per favore aggiungi clubBalance e riprova nuovamente",
      "claimBackWrongMessage1": "Vuoi prelevare {0} ma {1} hai disponibilita' di  {2}",
      "counterMessage2": "Preleva {0} da {1}",
      "emailDeleteInfo": "Le mail verranno cancellate dopo 30 giorni ",
      "subFotterText": "Termini e Condizioni ",
      "changeRoleConfirmation": "Sei sicuro di voler modificare i permesssi della user da",
      "bonusSuccess": "Congraturazioni, hai ricevuto  {0} di bonus!",
      "clubPlayerRemove": "Sicuro di voler abbandonare il Club?",
      "unableExport": "L'export del report non e' disponibile per il tuo account",
      "noMessages": "Non hai alcun messaggio",
      "deleteMessages": "Cancella messaggi",
      "deleteMessageInfo": "Questo messaggio verra' cancellato automaticamente dop 30 giorni ",
      "accountPrivilegeChange": {
        "header": "Richiesta cambio privilegi account",
        "body": "I privilegi del tuo account in {0} club sono  stati cambiati a {1}"
      },
      "removeFromClub": {
        "header": "Elimina notifiche dal Club",
        "body": "Il tuo account e' stato rimosso da {0} club."
      },
      "joinRequest": {
        "header": "Nuova richiesta partecipazione",
        "body": "Hai una nuova richiesta di ingresso al tuo {0} club dal {1} player"
      },
      "joinedToClub": {
        "header": "Sei entrato in un nuovo club",
        "body": "Sei entrato in  {0} club."
      },
      "balanceUpdate": {
        "header": "Richiesta aggiornamento bilancio",
        "body": "Il tuo bilancio {0} club e' cambiato. Il nuov bilancio e' {1}{2}."
      },
      "productExpiration": {
        "header": "Club Product will expire soon",
        "body": "Club product {0} will expire in 1 hour, at {1}."
      },
      "levelExpiration": {
        "header": "Club Rating will expire soon",
        "body": "Club rating will expire in 1 day, at {0}."
      }
    },
    "Renew now": {
      "": ""
    },
    "signInUp": {
      "username": "Username",
      "password": "Password",
      "agreement": "Ho letto {0} e {1}",
      "termsLink": "Termini e Conizioni",
      "privacyLink": "Privacy Policy"
    },
    "tabTitle": {
      "casino": "Casino",
      "regular": "Casino",
      "liveCasino": "Live Casino",
      "poker": "Poker",
      "betting": "Sport",
      "members": "Membri",
      "newMembers": "Nuovi membri",
      "trade": "Trade",
      "tradeRecord": "Trade Record",
      "selectDownline": "Select Downline",
      "grantCredit": "Grant Credit",
      "currentDownline": "Current Downline"
    },
    "maxClaimBack": "Massimo credito prelevabile per giocatore: {0}",
    "cancel": "Cancella",
    "confirm": "Conferma",
    "from": "da",
    "to": "a",
    "days": "giorni",
    "sendVip": "Invita VIP",
    "all": "Tutti",
    "returnToClubLobby": "Ritrona alla lobby del club",
    "returnToHomePage": "Ritorna alla home page ",
    "downline": "",
    "downlines": "",
    "pleaseWait": "Attendere prego",
    "allTime": "",
    "last7Days": "Ultimi 7 giorni ",
    "dialogTitleEmail": "EMAIL",
    "vipStatusOff": "Disabilitato",
    "vipValidDate": "( Valido per 30 giorni )",
    "logInNow": "Accedi ora",
    "haveAnAccount": "Hai un account?",
    "dialogTitlePopUp": "Email Popup",
    "member": "Membro",
    "manager": "Manager",
    "agent": "Agente",
    "player": "Membro",
    "userId": "User ID",
    "details": "Dettagli",
    "uplineAgent": "",
    "buyProduct": "Acquista prodotto",
    "leagueHeader": "",
    "gamesCareer": "",
    "total": "Totale",
    "tips": "Mance",
    "doYouConfirm": "Confermi?",
    "game": "Gioco ",
    "games": "Giochi",
    "sport": "Sport",
    "sports": "Sports",
    "poker": "Poker",
    "casino": "Casino",
    "regular": "Casino",
    "liveCasino": "Casino Live",
    "cashout": "Cashout",
    "multiBet": "Scommessa multipla",
    "systemBet": "System bet",
    "margin": "Margine",
    "theme": "Tema",
    "playerWinnings": "Vincite giocatore",
    "winnings": "Vincite ",
    "hand": "Mani",
    "join": "Accedi ",
    "joinClub": "Accedi al Club",
    "joinUnion": "",
    "createAClub": "Crea un club",
    "codeForClubCreation": "Inserisci il codice per creare il club",
    "sentTo": "Invia a",
    "exchange": {
      "chips": "Chips",
      "sapphires": "Zaffiri",
      "currentBalance": "Bilancio attuale",
      "currentExchange": "Cambio attuale",
      "sapphireExchange": "{0} Zaffiri = {1} Chips",
      "minExchangeAmount": "Importo minimo da cambiare",
      "convert": "Cambiare"
    },
    "createUnion": "",
    "grandCreditHistory": "",
    "soundEffects": "Effetti sonori",
    "memberEditing": "Modifica membro",
    "timeSliderName": "",
    "blindSliderName": "Buio",
    "gameLengthSliderName": "Game Length",
    "buyInSliderName": "Buy-in",
    "minBuyInText": "Min Buy-in:",
    "maxBuyInText": "Max Buy-in:",
    "newTableDialogTitle": "Nuovo Tavolo",
    "blinds": "Bui ",
    "clubLeague": "",
    "clubCapitalize": "Club",
    "clubId": "Club ID",
    "unionId": "",
    "agentId": "Agent ID",
    "id": "ID",
    "lv": "Lv",
    "fee": "Fee",
    "rake": "Rake",
    "pokerGames": "Poker Games",
    "spins": "Casino Spins",
    "bettings": "Scommesse",
    "wl": "Vincite",
    "nickname": "Nickname",
    "lastLogin": "Ultimo accesso",
    "create": "Crea",
    "createClub": "Crea Club",
    "selectAvatar": "Seleziona Avatar",
    "selectCountry": "Seleziona Nazione",
    "clubCreation": "Crea Club",
    "clubDescriptionAndRules": "Descrizione e regole del Club",
    "hands": "Mani ",
    "validFor": "Valido per",
    "levelUpdate": "Livello aggiornato",
    "wantToBuy": "Vuoi acquistare",
    "ourSubItem": "",
    "createNewClub": "Crea un nuovo club",
    "joinNewClub": "Accedi ad un Club",
    "clubName": "Nome Club",
    "clubNotice": "Avviso del club",
    "content": "Contenuto",
    "clubDisband": "Sei sicuro di voler eliminare il Club?",
    "deleteClubMember": "Sei sicuro di voler cancellare questo membro?",
    "changeRole": "Conferma il cambio del prifilo per il player",
    "changeRoleFromAgent": "\r\nI dati della downline corrente verranno rimossi se si modificano i diritti di questo agente. Sei sicuro?",
    "freeToRename": "Puoi rinominare la prima volta",
    "welcomeMessagePart1": "Benvenuto ",
    "welcomeMessagePart2": "Per eventuali richieste contatta",
    "loadingTablesList": "Lista tavoli in caricamento",
    "notificationIsValid": "Ogni notifica e' valida per 24h",
    "jackpot": "Jackpot",
    "commision": "Commissioni ",
    "selectDownline": "",
    "recruitedByTheAgent": "",
    "levelHasExpired": "\r\nIl tuo livello di club è scaduto, rinnova.",
    "grantSendOutLimit": "",
    "currentDownline": "",
    "agentManagement": "Agent Management",
    "wantToChangeDownline": "",
    "wantToRemove": "Sei sicuro di volere rimuovere",
    "notifications": "Notifiche",
    "quitTheClub": "Abbandona il club",
    "oddDefaultFormat": "",
    "clubChipBalance": "Bilancio chips del Club",
    "exchangeSapphires": "100 Zaffiri = 40",
    "multipleOf100": "",
    "clubEditing": "Club Editing",
    "startAnewTable": "Inizia in nuovo tavolo",
    "change": "Cambia",
    "coins": "Coins",
    "items": "",
    "sapphires": "",
    "clubHeadline1": "Non si puo' negare il fatto che il successo di una pubblicita' risiede principalmente nel titolo. il titolo dovrebbe attirare il ",
    "showMore": "Visualizza di piu'",
    "clubHeadline2": "lettore e fargli leggere il resto della pubblicita'. Il titolo dovrebbe essere semplicemente accattivante e vari punti chiave dovrebbero essere incorporati quando si decide il titolo dell'annuncio. Il titolo dovrebbe",
    "showLess": "Visualizza meno ",
    "disbandClub": "Per procedere con cancellazione del Club, inserisci il tuo Club ID nella stringa",
    "disbandUnion": "Per procedere con cancellazione dela Union, inserisci il tuo Club ID nella stringa",
    "quitTheUnion": "",
    "overall": "Totale",
    "yesterday": "Ieri",
    "past7Days": "Ultimi 7 giorni ",
    "lastWeek": "Ultima settimana",
    "currentWeek": "Settimana corrente ",
    "select": "Seleziona",
    "overallWinnings": "Vincite totali ",
    "pokerWinnings": "Vincite poker",
    "casinoWinnings": "Vincite Casino",
    "bettingWinnings": "Vincite Betting",
    "pokerFeeAmount": "Poker Fee Ammount ",
    "pokerFee": "Poker Fee",
    "overallWL": "Totale W/L",
    "pokerWL": "Poker W/L",
    "casinoWL": "Casino W/L",
    "liveCasinoWL": "Live Casino W/L",
    "sportsWL": "Sport W/L",
    "gamesPoker": "Poker Games",
    "spinsCasino": "Casino Spins",
    "deleteMember": "Cancella membro",
    "dateCreated": "",
    "chipBalance": "Bilancio Chip",
    "sent": "Inviato",
    "totalChips": "Totale chips giocatori escluse quelle in gioco",
    "yourChipsAmount": "Il tuo saldo chips",
    "chipsAmount": "Quantita' chips",
    "totalPlayersChipsAmount": "Totale chips giocatore escluse quelle in gioco ",
    "claimedBack": "Preleva",
    "tradeCommission": "{0}% commissioni applicate per questa operazione",
    "areComingSoon": "Presto disponibili",
    "nlh": "",
    "plo": "",
    "ofc": "",
    "ringGame": "",
    "sng": "",
    "mtt": "",
    "regularMode": "",
    "progressiveMode": "",
    "ultimateMode": "",
    "sixPlus": "6+",
    "fourCard": "4 carte",
    "fiveCard": "5 carte ",
    "concurrent": "",
    "sequential": "",
    "operationSequence": "",
    "autoStart": "Auto Start",
    "autoExtension": "",
    "times": "",
    "autoOpen": "",
    "riskManagement": "Gestione del rischio",
    "multiTimeRun": "",
    "evChop": "",
    "cap": "Cap",
    "callTime": "",
    "autorizedToBuyin": "",
    "byh": "",
    "gpsRestriction": "Restrizione GPS",
    "ipRestriction": "Restrizione IP",
    "banChatting": "",
    "tableCost": "",
    "balance": "Bilancio",
    "grantCredit": "",
    "selectDownlineText": "",
    "creditBalance": "",
    "clubBalance": "Bilancio del Club",
    "grantCreditText": "",
    "unionClubs": "",
    "unionJoinRequests": "Richieste di partecipazione",
    "unionData": "",
    "unionEditingContent": {
      "change": "Cambia",
      "label": "Union Name",
      "notice": "La prima volta puoi rinominare",
      "save": "Salva",
      "price": "Cambio nome Club",
      "notEnough": {
        "0": "Non hai abbstanza Zaffiri",
        "1": "Clicca qua",
        "2": "per comerare Zaffiri"
      }
    },
    "information": "Informazione",
    "dataIsRecordedBasedOnUnionHeadData": "",
    "pokerWinLossFee": "Poker Win / Lose + Fee",
    "pokerWinLossFeeOverall": "Totale",
    "pokerWinLossFeeLastWeek": "Scorsa settimana",
    "pokerWinLossFeeThisWeek": "Questa settimana ",
    "suspend": "Sospeso",
    "remove": "Rimuovi",
    "exportData": "Export Data ",
    "betYourHand": {
      "combinations": "Combinazioni ",
      "amount": "X1 / X2",
      "max": "Max",
      "nlh": {
        "0": {
          "title": "QQ Royal Flush",
          "description": "(A234567 in any suit using both of your hole cards and all 5 cards on the board)",
          "amount": "100.000",
          "max": "250.000",
          "combinations": "QQRoyalFlush"
        },
        "1": {
          "title": "Super Royal Flush",
          "description": "AKQJT in 1 suit, using both of your hole cards and the first 3 cards on the board",
          "amount": "30.000",
          "max": "50.000",
          "combinations": "superRoyalFlush"
        },
        "2": {
          "title": "Royal Flush",
          "description": "AKQJT in 1 suit",
          "amount": "10.000",
          "max": "10.000",
          "combinations": "royalFlush"
        },
        "3": {
          "title": "Straight Flush",
          "description": "Any straight in 1 suit",
          "amount": "1.500",
          "max": "1.500",
          "combinations": "straightFlush"
        },
        "4": {
          "title": "Quattro di un tipo",
          "description": "Nessuna delle 4 di un tipo ",
          "amount": "200",
          "max": "200",
          "combinations": "fourOfKind"
        },
        "5": {
          "title": "Full House Aces",
          "description": "3 Aces + 2 cards same rank",
          "amount": "100",
          "max": "100",
          "combinations": "fullHouseAces"
        },
        "6": {
          "title": "Ace High Straight",
          "description": "Straught, Ace High AKQJT",
          "amount": "10",
          "max": "10",
          "combinations": "aceHighStraight"
        },
        "7": {
          "title": "Ace High Flush",
          "description": "Ace + Any 4 cards in the same suit",
          "amount": "10",
          "max": "10",
          "combinations": "aceHighFlush"
        },
        "8": {
          "title": "Three of a Kind Aces",
          "description": "3 Aces",
          "amount": "10",
          "max": "10",
          "combinations": "threeOfKindAces"
        }
      },
      "plo": {
        "0": {
          "title": "QQ Royal Flush",
          "description": "A234567 in any suit",
          "amount": "100.000",
          "max": "250.000",
          "combinations": "QQRoyalFlush"
        },
        "1": {
          "title": "Super Royal Flush",
          "description": "AKQJT in 1 suit, using both of your hole cards and the first 3 cards on the board",
          "amount": "30.000",
          "max": "50.000",
          "combinations": "superRoyalFlush"
        },
        "2": {
          "title": "Royal Flush",
          "description": "AKQJT in 1 suit",
          "amount": "10.000",
          "max": "10.000",
          "combinations": "royalFlush"
        },
        "3": {
          "title": "Straight Flush",
          "description": "Any straight in 1 suit",
          "amount": "1.500",
          "max": "1.500",
          "combinations": "straightFlush"
        },
        "4": {
          "title": "Four of a Kind",
          "description": "Any 4 of a kind",
          "amount": "200",
          "max": "200",
          "combinations": "fourOfKind"
        },
        "5": {
          "title": "Full House Aces",
          "description": "3 Aces + 2 cards same rank",
          "amount": "100",
          "max": "100",
          "combinations": "fullHouseAces"
        },
        "6": {
          "title": "Ace High Straight",
          "description": "Straught, Ace High AKQJT",
          "amount": "10",
          "max": "10",
          "combinations": "aceHighStraight"
        },
        "7": {
          "title": "Ace High Flush",
          "description": "Ace + Any 4 cards in the same suit",
          "amount": "10",
          "max": "10",
          "combinations": "aceHighFlush"
        }
      }
    },
    "exportRecord": "Esporta record",
    "exportDate": "Esporta data ",
    "pleaseEnterValidEmail": "Inserisci una mail valida",
    "playerData": "PlayerData ",
    "sapphireStatement": "",
    "tradeRecord": "",
    "tradeRecords": "",
    "upgradeToJoinText": "",
    "upgradeToCreateText": " ",
    "clubDataHelp": {
      "0": {
        "0": "Totale",
        "1": "Visualizza i dati da quando la user e' nel club"
      },
      "1": {
        "0": "Ultimi 7 giorni ",
        "1": "Visualizza i dati degli ultimi 7 giorni"
      },
      "2": {
        "0": "Seleziona",
        "1": "Visualizza i dati per le date selezionate"
      },
      "3": {
        "0": "Totale delle vincite",
        "1": "Visualizza il totale delle chips che la usr ha vinto/perso in tutti i giochi"
      },
      "4": {
        "0": "Vincite Poker",
        "1": "Visualizza il totale delle chips che la usr ha vinto/perso nel poker"
      },
      "5": {
        "0": "Vincite Casino",
        "1": "Visualizza il totale delle chips che la usr ha vinto/perso nel Casino"
      },
      "6": {
        "0": "Importo Fee",
        "1": "Shows amount of Poker Feeâ€™s given to the club"
      }
    },
    "footer": {
      "items": {
        "home": "Home",
        "shop": "Shop",
        "career": "Career",
        "profile": "Profilo",
        "messages": "Messaggi",
        "settings": "Impostazioni",
        "data": "Dati",
        "members": "Membri",
        "counter": "Counter"
      }
    },
    "agentDetails": {
      "memberAmount": "Member Amount {0}"
    },
    "language": {
      "en": "Inglese",
      "tr": "Turco",
      "id": "Indonesiano",
      "de": "Tedesco",
      "ar": "Arabo",
      "fr": "Francese",
      "pt": "Portoghese"
    },
    "dialog": {
      "tutorial": "Tutorial",
      "createClub": "Crea Club",
      "createAClub": "Crea un club",
      "joinClub": "Entra nel Club",
      "selectAvatar": "Seleziona Avatar",
      "selectCountry": "Seleziona Nazione",
      "coins": "Coins",
      "notification": "Notifica",
      "sapphires": "Sapphires",
      "exchange": "Cambio",
      "editClub": "Modifiche Club",
      "disbandClub": "Elimina Club",
      "disbandUnion": "Disband The Union",
      "deleteMember": "Conferma ",
      "editMemberInfo": "Modifica info membro",
      "changeRole": "Conferma ",
      "mission": "Mission",
      "unionNotice": "Union Notice",
      "joinUnion": "Join A Union",
      "createUnion": "Create A Union",
      "createLabel": "Enter Union Name",
      "joinLabel": "Enter Union ID",
      "unionAuthority": "Autorita'",
      "selectAuthority": {
        "text": "Select the authority to create Poker tables",
        "current": "Attuali Proprietari e Manager del Club",
        "all": "Tutti i Pbroprieatri e Manager dei Club"
      },
      "unionConfirm": "Conferma",
      "unionTerms": {
        "one": "1. Only two-star Clubs or above are able to create or join a Union.",
        "two": "2. After creating or joining a Union, Chips retained in your club will still be available in that particular Union. However, Chips held by the agents and players will be removed",
        "agreement": "Ho letto termini e condizioni"
      },
      "clubDetails": "Dettagli del Club",
      "upgradeToCreate": "Can not Create a Union",
      "upgradeToJoin": "Can not Join a Union",
      "unionConfirmation": "Union Details",
      "clubConfirmation": "Dettagli del Club",
      "renewLevel": "Non puoi creare il tavolo",
      "agentDetails": "Dettagli Agente",
      "quitTheUnion": "Quit The Union",
      "export": "Export",
      "notEnoughFunds": "Fondi non sufficienti",
      "memberMenu": "Dettagli del Club",
      "betYourHand": "Quote",
      "enterAmount": "Inserisci importo"
    },
    "settings": {
      "text": "Impostazioni",
      "twoStepVerification": "Due passaggi per la verifica",
      "changePassword": "Cambia password",
      "changeEmail": "Cambia Email",
      "languages": "Lingue",
      "avatar": "Avatar",
      "details": "Dettagli del Club",
      "linkEmail": "Associa la tua mail",
      "language": "Lingue",
      "select": "Seleziona",
      "logOut": "Esci"
    },
    "clubLevelName": {
      "1": "Club una stella",
      "2": "Club due stelle",
      "3": "Club tre stelle",
      "4": "Club quattro stelle",
      "5": "Club cinque stelle",
      "6": "Club sei stelle",
      "7": "Club sette stelle",
      "8": "Club otto stelle",
      "9": "Club nove stelle",
      "10": "Club 10 stelle",
      "11": "Super star Club"
    },
    "changePassword": {
      "text": "Cambia password",
      "current": "Password attuale",
      "new": "Nuova Password",
      "repeat": "Conferma password",
      "confirm": "Conferma "
    },
    "linkEmail": {
      "text": "Abbina la tua mail",
      "writeYourEmail": "Scrivi qua la tua mail e ti invieremo il codice di verifica",
      "emailAddress": "Indirizzo mail",
      "resendCode": "Reinvia il codice verifica",
      "checkYourMail": "Per favore controlla nella tua mial il codice verifica, controlla che la mail non sia in spam",
      "verificationCode": "Codice verifica",
      "unverifiedCode": "Codice verifica errato",
      "alreadyLinked": "Gia' collegato"
    },
    "passwordRecovery": {
      "emailField": "Indirizzo mail",
      "title": "Recupera password",
      "description": "Scrivi indirizzo mail che hai utilizzato per la registrazione",
      "sendEmail": "Invia mail",
      "successDescription": "Ti inviamo una nuova password temporanea. Puoi usarla per entrare nel gioco, dopo aver effettuato l'accesso puoi modificare la password nel menu Impostazioni di gioco",
      "goBack": "Torna indietro"
    },
    "tutorial": {
      "text": "Tutorial",
      "accountSettings": "Account Impostazioni ",
      "leagueGames": "League Games",
      "clubs": "Clubs",
      "shop": "Shop",
      "dailyBonus": "Bonus giornaliero",
      "accountLevelsAndXP": "Account levels and XP",
      "friendInvite": "Invita un amico"
    },
    "about": {
      "text": "Chi siamo",
      "gameRules": "Regole del gioco",
      "contactInfo": "Contatti",
      "termsAndConditions": "Termini e condizioni",
      "privacyPolicy": "Privacy policy"
    },
    "leaderboard": {
      "text": "Leaderboard",
      "remaining": "Tempo rimanente",
      "rank": "Classifica",
      "name": "Nome",
      "points": "I tuoi puti",
      "reward": "Ricompensa",
      "daily": "Giornaliero",
      "weekly": "Settimanale",
      "monthly": "Mensile"
    },
    "leaderboardInfo": {
      "text": "Informazioni sulle classifiche",
      "hints": "Suggerimenti",
      "rewards": "Ricompense"
    },
    "leaderboardHints": {
      "text": "Suggerimenti",
      "rule": "Giocando in campionato o in club, il giocatore guadagnerà punti e parteciperà alle classifiche. Entro la fine del timer i giocatori che sono tra i primi dieci riceveranno dei premi.",
      "hintsText": {
        "0": {
          "header": "Suggerimento 1.",
          "text": "Puoi guadagnare punti in classifica giocando a poker, giochi da casinò e facendo scommesse in campionato e club."
        },
        "1": {
          "header": "Suggerimento 2.",
          "text": "Giocare e fare scommesse nei club ti darà più punti delle partite di campionato"
        },
        "2": {
          "header": "Sugegrimento 3.",
          "text": "I punti sono definiti dalla quantità di denaro che vinci, una grande scommessa ti darà una ricompensa maggiore e anche molti punti."
        },
        "3": {
          "header": "Suggerimento 4.",
          "text": "I tuoi punti verranno ripristinati al termine del timer. Ma se non sei riuscito a entrare nella top 20 nelle classifiche giornaliere, avrai comunque la possibilità di aumentare quei punti e entrare nella top 20 nelle classifiche settimanali o mensil"
        }
      }
    },
    "level": {
      "currentXp": "Current XP",
      "requiredXp": "Required XP",
      "gainXp": "Play poker, casino or do in order to gain XP and level up",
      "accountLevel": "Account Level",
      "levelRewards": "Levello {0} Ricompense"
    },
    "shop": {
      "text": "Shop",
      "coins": {
        "text": "Coins"
      },
      "items": {
        "text": "Items",
        "silverCard": "Carata Argento",
        "goldCard": "Carta Oro",
        "platinumCard": "Carta Platino ",
        "avatars": "Avatars",
        "emojis": "Emojis"
      },
      "sapphires": {
        "text": "Zaffiri"
      },
      "mostPopular": "Piu' popolari",
      "bestValue": "Migliore valore"
    },
    "support": {
      "text": "Supporto"
    },
    "time": {
      "s15": "15s",
      "s20": "20s",
      "s30": "30s"
    },
    "number": {
      "one": "1",
      "onePointFive": "1.5",
      "two": "2",
      "twoPointFive": "2.5",
      "three": "3",
      "fout": "4",
      "five": "5",
      "six": "6"
    },
    "dash": {
      "claimBack": "Preleva",
      "buyIn": "Buy-in"
    },
    "button": {
      "ok": "OK",
      "confirm": "Conferma",
      "cancel": "Cancella",
      "claimBack": "Preleva",
      "sendOut": "Inviato",
      "send": "Invia",
      "oneMore": "Ancora uno",
      "buy": "Buy",
      "done": "Fatto",
      "submit": "Iniva",
      "quit": "Lascia il Club",
      "sapphire": "Zaffiro ",
      "select": "Sleziona",
      "save": "Salva",
      "sendVip": "Invia VIP",
      "upgrade": "Aggiorna",
      "close": "Chiudi",
      "create": "Crea",
      "join": "Entra",
      "apply": "Applicare",
      "claim": "Richiesta ",
      "linkYourEmail": "Abbina la tua mail"
    },
    "header": {
      "clubData": "Dati Club",
      "clubDetails": "Dettagli Club",
      "clubChips": "Club Chips",
      "clubRating": "Club Rating",
      "title": "Titolo"
    },
    "playerMenu": {
      "playerMenuTitle": "Dettaglio giocatore",
      "trade": "Trade Record",
      "jackpot": "Jackpot",
      "quit": "Abbandona il Club"
    },
    "agentMenu": {
      "agentMenuTitle": "Dettagli Agente",
      "grantCredit": "Grant Credit"
    },
    "career": {
      "items": {
        "poker": "Mani ",
        "sportsbook": "Bets",
        "casino": "Bets"
      },
      "periods": {
        "day": "giorno",
        "month": "mese",
        "year": "anno"
      },
      "range": {
        "all": "Sempre",
        "lastWeek": "Ultimi 7 giorni",
        "purchase": "Acquista una carta Gold o superiore per dati più dettagliati"
      },
      "reports": {
        "game": "Gioco",
        "hand": "Mano"
      },
      "menu": {
        "filters": "Filtri"
      },
      "menuRow": {
        "all": "Tutto",
        "poker": "Poker",
        "casino": "Casino",
        "betting": "Betting"
      }
    },
    "options": {
      "clubChips": "{1} Chips {0}",
      "newMessage": "Notifiche",
      "buyLevel": "Club Rating LVL {0}",
      "promotion": "Promozione",
      "disband": "Elimina il Club",
      "leftDays": "({0} giorni rimasti)",
      "grandCredit": "Grand Credit History",
      "quit": "Abbandona il Club"
    },
    "union": {
      "clubs": "Union Clubs",
      "requests": "Richieste di partecipazioni",
      "data": "Union Data",
      "authority": "Autorizzazione a creare tavoli di poker ",
      "disband": "Disband The Union",
      "quit": "Quit The Union"
    },
    "club": {
      "text": "Club",
      "poker": "Poker",
      "betting": "Betting",
      "casino": "Casino",
      "games": {
        "poker": {
          "admin": "Attualmente i giochi da casinò non sono disponibili. Per renderlo disponibile, rinnova la tua valutazione del club",
          "member": "\r\nAl momento non ci sono tavoli da poker disponibili"
        },
        "casino": {
          "admin": "Attualmente i giochi da casinò non sono disponibili. Per renderlo disponibile, rinnova la tua valutazione del club",
          "member": "\r\nAl momento i Casino games non sono disponibili"
        },
        "betting": {
          "admin": "Attualmente lo Sport non e' disponibile. Per renderlo disponibile, rinnova la tua valutazione del club",
          "member": "Al momento lo Sport non e' disponibile",
          "enterText": "Premere il pulsante per entrare nella sezione sport",
          "goToSports": "Vai agli Sport"
        },
        "renew": "Rinnovare"
      }
    },
    "clubItems": {
      "options": "Opzioni Club",
      "notifications": "Notifiche",
      "members": "Maggiori dettagli",
      "counter": "Contatore",
      "tradeRecords": "Trade Records",
      "memberDetails": "Dettagli membro",
      "clubRatings": "Club Ratings",
      "claimBack": "Riscuoti ",
      "sendOut": "Inviato ",
      "data": "Dati Club",
      "union": "Union",
      "unionEditing": "Union Editing",
      "agentMenu": "Manu agente"
    },
    "memberDetails": {
      "trackPlayer": "Track Player",
      "roleSelection": "Role Selection",
      "clubRatings": "Club Ratings",
      "editMemberInfo": {
        "alias": "Aggiungi nickname",
        "notes": "Aggiungi note"
      }
    },
    "tradeDirection": {
      "sent": "Inviato a:",
      "claimedBack": "Riscosso da"
    },
    "members": "Membri",
    "newMembers": "Nuovo membro",
    "betting": "Sport",
    "title": "Titolo",
    "chips": "Chips",
    "currentPassword": "Password attuale",
    "newPassword": "Nuova Password",
    "repeatPassword": "Ripeti Password",
    "email": "Email",
    "login": "Accedi",
    "version": "Versione",
    "loginObj": {
      "text": "Non hai un account?",
      "link": "Registrati ora!"
    },
    "registerObj": {
      "text": "Hai gia' un account?",
      "link": "Registrati"
    },
    "forgotPassword": "Password dimenticata",
    "loginBonus": "Accesso Bonus",
    "insurance": "Assicurazione",
    "totalPokerFees": "Fee Totali Poker",
    "pokerFees": "Poker Fee",
    "totalWinnings": "Totale vincite",
    "winningsLastWeek": "Vincite del'ultima settimana",
    "winningsThisweek": "Vincite di questa settimana",
    "downlinesChips": "",
    "chipsInPlay": "Chips in gioco",
    "invalidEmail": "Email non valida",
    "fullScreenHint": "Press on \"aA\" button than select \"Hide ToolBar\" button for full screnn",
    "dismissFullScreen": "Esci dallo schermo full screen",
    "last24Hour": "Ultime 24h",
    "customRange": "Perido personalizzato",
    "lastMonth": "Ultimo mese",
    "date": "Data",
    "type": "Tipo",
    "gameTransfers": "",
    "transfers": "Trasferimenti "
  }